export function getEnv(param: string): string {
    return '';
}

declare global {
    interface Window {
        dataLayer: Array<Record<string, unknown>>;
    }
}

export const LANGUAGES: Record<string, string> = {
    pl: 'pl',
    en: 'en-GB',
    de: 'de-DE',
    it: 'it-IT'
};

export const pushToDataLayer = (
    name: string | undefined,
    body?: Record<string, unknown>
) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ...(name && {event: name}),
        ...body
    });
};

const {pl, de, en, it} = LANGUAGES;

const privacyPolicyLinks = {
    [pl]: 'https://help.sundose.io/hc/pl/articles/360015278959',
    [en]: 'https://help.sundose.io/hc/en-gb/articles/360015278959',
    [de]: 'https://help.sundose.io/hc/de/articles/360015278959',
    [it]: 'https://help.sundose.io/hc/en-gb/articles/360015278959' // until we have IT translation we use EN
    // [it]: 'https://help.sundose.io/hc/it/articles/360015278959'
};

export const getPrivacyPolicyLink = (lang: string = 'pl') => privacyPolicyLinks[LANGUAGES[lang]];